import {Component, OnInit} from '@angular/core';
import {ViewportScroller} from '@angular/common';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

    constructor(private viewportScroller: ViewportScroller) {}

    public onClick(elementId: string): void {
        this.viewportScroller.scrollToAnchor(elementId);
    }

    ngOnInit() {
    }

    submit(form: any): void{
        const name = form.name;
        console.log(name);

        const email = form.email;
        console.log(email);

        const phoneNumber = form.number;
        console.log(phoneNumber);

        const subject = form.subject;
        console.log(subject);

        const message = form.message;
        console.log(message);
    }

}
